/** Identidade visual do app, num lugar só. */
export const APP_INFO = {
  name: 'Arquivador',
  /** Linha abaixo do nome, no topo da navegação. */
  tagline: 'Gestão de Documentos',
  /** Logo do bloco da marca, em `public/`. */
  logo: '/icon.png',
  /**
   * Arte de identidade ao fundo das páginas (campanhas, por exemplo), em
   * `public/assets/`. `null` deixa só o fundo neutro, como o do Teams. Ao
   * trocar o arquivo, aumente o `?v=` para o navegador não usar o antigo.
   */
  identityArt: null as string | null,
  /** Quanto da cor de fundo cobre a arte (0 a 100). Mais alto, mais discreta. */
  identityArtVeil: 62,
} as const;
